import React,
{
  Component, useEffect, useRef, useCallback,
}
  from 'react';
import PropTypes from 'prop-types';
import { addErrorToReport } from '@americanexpress/one-app-ducks';

const ErrorListener = ({ dispatch, children }) => {
  const isReportingRef = useRef(false);

  const reportError = useCallback((error, meta) => {
    if (isReportingRef.current) return;
    isReportingRef.current = true;
    Promise.resolve(dispatch(addErrorToReport(error, meta)))
      ?.catch?.(() => {})
      .finally(() => { isReportingRef.current = false; });
  }, [dispatch]);

  const handleOnError = useCallback((event) => {
    reportError(event.error || event, {
      message: event.message,
      file: event.filename,
      line: event.lineno,
      col: event.colno,
      collectionMethod: 'onerror',
    });
  }, [reportError]);

  const handleUnhandledRejection = useCallback((error) => {
    reportError(error, { collectionMethod: 'unhandledrejection' });
  }, [reportError]);

  useEffect(() => {
    window.addEventListener('error', handleOnError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    return () => {
      window.removeEventListener('error', handleOnError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, [handleOnError, handleUnhandledRejection]);

  return children || null;
};

ErrorListener.propTypes = {
  children: PropTypes.node,
  dispatch: PropTypes.func.isRequired,
};

ErrorListener.defaultProps = {
  children: null,
};

class ErrorReporter extends Component {
  componentDidCatch(error) {
    const { dispatch } = this.props;
    Promise.resolve(dispatch(addErrorToReport(error)))
      ?.catch?.(() => {});
  }

  render() {
    const { children, dispatch } = this.props;
    return (
      <ErrorListener dispatch={dispatch}>
        {children}
      </ErrorListener>
    );
  }
}

ErrorReporter.propTypes = {
  children: PropTypes.node,
  dispatch: PropTypes.func.isRequired,
};

ErrorReporter.defaultProps = {
  children: null,
};

export { ErrorListener };
export default ErrorReporter;
